<template>
  <div class="classContainer">
    <van-nav-bar
      title="学员列表"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="listBox">
      <van-search
        v-model="keyword"
        shape="round"
        placeholder="请输入姓名、工号、手机号搜索"
        @search="onSearch"
        clearable
        show-action
        @cancel="onCancel"
      />
      <div class="listBox-item" v-for="(item, index) in studentList" :key="item.id" @click="handleClock(item)">
        <div class="left">
          <img src="@/assets/images/avatar.png" alt="" />
          <div class="content-info">
            <div class="name">
              {{item.realName}}
            </div>
            <div class="identity">
              {{item.className?item.className:'-'}}
            </div>
          </div>
        </div>
        <div class="right">
          <span v-if="operationType == 'rating'" :class="item.ratingCriteriaStatus == 1?'gray':''">{{item.ratingCriteriaStatus == 1?'已评价':'待评价'}}</span>
          <span v-if="operationType == 'paper'" :class="item.paperStatus == 1?'gray':''" @click="completed(item)">{{item.paperStatus == 1?'已完成':'待完成'}}</span>
          <img v-if="operationType == 'rating'" src="@/assets/images/rightArrow.png" alt="" />
        </div>
      </div>
    </div>
    <van-dialog v-model="showScore" title="评分"  :show-confirm-button="isEditScore != 1" show-cancel-button confirmButtonColor="#3776ff" :before-close="beforeClose" @confirm="confirmScore">
<!--      <van-field-->
<!--        :disabled="isEditScore == 1"-->
<!--        class="noteTextarea"-->
<!--        v-model="criteriaGrade"-->
<!--        type="digit"-->
<!--        input-align="center"-->
<!--        placeholder="请输入分数"-->
<!--      />-->
      <van-form :label-width="50">
        <van-field
          type="digit"
          name="criteriaGrade"
          v-model="criteriaGrade"
          label="得分："
          placeholder=""
          :rules="[{ pattern, message: '请输入0-100之间的整数' }]"
        />
        <van-field
          v-model="criteriaRemark"
          name="criteriaRemark"
          type="text"
          label="备注:"
          placeholder=""
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import {listPaperStudent, teachingPlanStudent,updateScoreCriteriaBatch} from "@/api/classSchedule";
import { Toast } from 'vant'
export default {
  name: "checkStudent",
  data() {
    return {
      planDetailId:'',
      ratingCriteriaId:'',
      paperId:'',
      studentList:[],
      keyword: '',
      operationType:'paper',
      ratingCriteriaStatus:'',
      showScore:false,
      criteriaGrade:'100',
      criteriaRemark:'',
      userId:'',
      isEditScore:0,
      pattern:/^(?:[0-9][0-9]?|100)$/
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1)
    },
    async getStudentList(){
      let res;
      if(this.operationType == 'rating'){
        res = await teachingPlanStudent({planDetailId:this.planDetailId,ratingCriteriaStatus:this.ratingCriteriaStatus,keyword:this.keyword});
      }else{
        res = await listPaperStudent({planDetailId:this.planDetailId,paperId:this.paperId,keyword:this.keyword});
      }
      this.studentList = res.data;
    },
    handleClock(item){
      if(this.operationType == 'rating'){
        if(this.ratingCriteriaStatus == '1'){
          this.$router.push('/ratingScale?userName='+item.userName+'&userId='+item.userId+'&planDetailId='+this.$route.query.planDetailId+'&ratingCriteriaId='+item.ratingCriteriaId+'&criteriaInstanceId='+item.criteriaInstanceId+'&ratingCriteriaStatus='+item.ratingCriteriaStatus)
        }
        if(this.ratingCriteriaStatus == '2'){
            this.showScore = true
            this.criteriaGrade = item.criteriaGrade!=null?item.criteriaGrade:100;
            this.criteriaRemark = item.criteriaRemark?item.criteriaRemark:'';
            this.userId = item.userId?item.userId:'';
            this.isEditScore = item.ratingCriteriaStatus;//1已评，0未评
        }
      }
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        done(false);
      } else {
        done();
      }
    },
    async confirmScore(){
      if(this.criteriaGrade>100 || this.criteriaGrade<0){
        Toast('分数范围为0-100');
        return;
      }
      let params = [{
        planDetailId:this.planDetailId,
        userId:this.userId,
        criteriaGrade:this.criteriaGrade,
        criteriaRemark:this.criteriaRemark,
      }];
      let res = await updateScoreCriteriaBatch(params)
      this.showScore = false;
      this.getStudentList()
    },
    onSearch(){
      this.getStudentList()
    },
    onCancel(){
      this.keywords = ''
      this.getStudentList()
    },
    completed(item) {
      if(item.paperStatus == 1) {
         this.$router.push({
         path: "/scoreReport",
         query: {
          type: 2,
          queryType: 1,
          // paperStatus: item.paperStatus,
          userId: item.userId,
          paperId: item.paperId,
          planDetailId: this.planDetailId,
        },
       });
      }
    },
  },
  mounted() {
    this.operationType = this.$route.query.operationType;
    this.planDetailId = this.$route.query.planDetailId;
    this.ratingCriteriaId = this.$route.query.ratingCriteriaId;
    this.ratingCriteriaStatus = this.$route.query.ratingCriteriaStatus;
    this.paperId = this.$route.query.paperId;
    this.getStudentList()
  },
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
.listBox {
  height: calc(100vh - 46px);
  overflow-y: auto;
  padding: 16px;
  padding-top: 0;

  .listBox-item {
    width: 341px;
    height: 80px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      height: 48px;
      display: flex;
      img {
        height: 48px;
        width: 48px;
      }
      .content-info {
        margin-left: 12px;
        .name {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 15px;
          color: #121212;
          line-height: 21px;
          font-style: normal;
        }
        .identity {
          margin-top: 6px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #000000;
          line-height: 18px;
          font-style: normal;
          max-width: 200px;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #3776FF;
      .gray{
        color: #8F91A1;
      }
      // width: 32rpx;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
